import { render, staticRenderFns } from "./EventTrends.vue?vue&type=template&id=0b98d66b&scoped=true"
import script from "./EventTrends.vue?vue&type=script&lang=js"
export * from "./EventTrends.vue?vue&type=script&lang=js"
import style0 from "./EventTrends.vue?vue&type=style&index=0&id=0b98d66b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98d66b",
  null
  
)

export default component.exports